import { useEffect, useState } from "react";
import { formatPence, formatTokenUnits } from "../lib/money";
import { getUiMultiplierE18 } from "../lib/prices";
import { currentValuePence, portfolioTotals, useAppState } from "../lib/store";

export function PortfolioScreen() {
  const s = useAppState();
  const totals = portfolioTotals(s.roundups, s.settings.stockSymbol, s.settings.currency);
  const [valuePence, setValuePence] = useState<number | null>(null);
  // ERC-8056: displayed shares = raw units × uiMultiplier / 1e18 (splits and
  // dividend reinvestment move the multiplier, not the raw balance).
  const [shareUnits, setShareUnits] = useState(totals.stockUnits);

  useEffect(() => {
    let alive = true;
    void currentValuePence(totals.stockUnits, s.settings.stockSymbol, s.settings.currency).then((v) => {
      if (alive) setValuePence(v);
    });
    void getUiMultiplierE18(s.settings.stockSymbol, !s.settings.demoMode).then((m) => {
      if (alive) setShareUnits((totals.stockUnits * m) / 10n ** 18n);
    });
    return () => {
      alive = false;
    };
  }, [totals.stockUnits, s.settings.stockSymbol, s.settings.demoMode, s.settings.currency]);

  const gain = valuePence !== null ? valuePence - totals.investedPence : 0;

  return (
    <div className="screen">
      <h1>Portfolio</h1>
      <p className="sub">Built entirely from spare change.</p>

      <div className="card">
        <div className="balance-label">{s.settings.stockSymbol}</div>
        <div className="balance-value accent" style={{ fontSize: 32 }}>
          {valuePence !== null ? formatPence(valuePence, s.settings.currency) : "—"}
        </div>
        <div className="balance-note">
          {formatTokenUnits(shareUnits, 18, 6)} shares ·{" "}
          {gain >= 0 ? "+" : ""}
          {formatPence(gain, s.settings.currency)} vs invested
        </div>
      </div>

      <div className="card">
        <div className="kv">
          <span className="k">Total invested</span>
          <span className="v">{formatPence(totals.investedPence, s.settings.currency)}</span>
        </div>
        <div className="kv">
          <span className="k">Round-ups completed</span>
          <span className="v">{totals.count}</span>
        </div>
        <div className="kv">
          <span className="k">Queued round-ups</span>
          <span className="v">{formatPence(totals.pendingPence, s.settings.currency)}</span>
        </div>
      </div>

      <h2>Round-up reserve</h2>
      <div className="card">
        <div className="kv">
          <span className="k">Remaining</span>
          <span className="v">{formatPence(s.reservePence, s.settings.currency)}</span>
        </div>
      </div>
    </div>
  );
}
